import { API } from '../../utility/API'

// Trading API endpoint for account deletion
export const deleteTradingAccount = async (uid) => {
    const response = await API.delete('/trading/account/delete_account', {
        data: { uid }
    })
    return response.data
}

// Auth API endpoint for account deletion
export const deleteAuthAccount = async (uid, deleteReason) => {
    const response = await API.delete('/authenticate/identity/users/delete_account', {
        data: {
            uid,
            delete_reason: deleteReason
        }
    })
    return response.data
}

// Combined account deletion function
export const deleteUserAccount = async (uid, deleteReason) => {
    // First call trading API, then auth API as per requirements
    await deleteTradingAccount(uid)
    await deleteAuthAccount(uid, deleteReason)
    return { success: true }
} 